<template>
  <div class="whatsapp-templates-container">
    <div class="field">
      <label class="label">תבניות הודעות WhatsApp</label>

      <!-- Template 1: Interest Check -->
      <div class="field">
        <label class="label">נוסח מס' 1 - הודעת בדיקת התעניינות:</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="templates.interest"
            :placeholder="defaultTemplates.interest"
            rows="4"
            dir="rtl"
            style="text-align: right;"
          ></textarea>
        </div>
        <p class="help is-info">
          משתנים זמינים: [שם המועמד], [שם פרטי], [שם האופרציה], [שם המשרה]
        </p>
      </div>

      <!-- Template 2: Info Request -->
      <div class="field">
        <label class="label">נוסח מס' 2 - הודעת בקשה לקבלת מידע לבדיקת התאמה:</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="templates.infoRequest"
            :placeholder="getDefaultInfoRequestTemplate()"
            rows="4"
            dir="rtl"
            style="text-align: right;"
          ></textarea>
        </div>
        <p class="help is-info">
          משתנים זמינים: [שם המועמד], [שם פרטי], [שם האופרציה], [שם המשרה]
        </p>
      </div>

      <!-- Template 3: Conversation End -->
      <div class="field">
        <label class="label">נוסח מס' 3 - הודעת סיום שיחה:</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="templates.conversationEnd"
            :placeholder="getDefaultConversationEndTemplate()"
            rows="6"
            dir="rtl"
            style="text-align: right;"
          ></textarea>
        </div>
        <p class="help is-info">
          משתנים זמינים: [שם המועמד], [שם פרטי], [שם האופרציה], [שם המשרה], [קישור לעמוד המשרות של אופרציה רלווונטית]
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsappTemplates',
  props: {
    value: {
      type: Object,
      default: () => ({
        interest: '',
        infoRequest: '',
        conversationEnd: ''
      })
    }
  },
  data () {
    return {
      templates: {
        interest: '',
        infoRequest: '',
        conversationEnd: ''
      },
      defaultTemplates: {
        interest: 'היי [שם המועמד], מה שלומך?\nזו [שם פרטי] מ-[שם האופרציה]. ורציתי לבדוק האם משרה של [שם המשרה] יכולה לעניין אותך?'
      },
      isUpdatingFromParent: false
    }
  },
  watch: {
    templates: {
      handler (newVal) {
        // Only emit if we're not updating from parent
        if (!this.isUpdatingFromParent) {
          this.$emit('input', newVal)
        }
      },
      deep: true
    },
    value: {
      handler (newVal) {
        if (newVal && !this.isUpdatingFromParent) {
          this.isUpdatingFromParent = true
          this.templates = {
            interest: newVal.interest || '',
            infoRequest: newVal.infoRequest || '',
            conversationEnd: newVal.conversationEnd || ''
          }
          // Use nextTick to ensure the update is complete
          this.$nextTick(() => {
            this.isUpdatingFromParent = false
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    // Initialize templates from value prop
    if (this.value) {
      this.isUpdatingFromParent = true
      this.templates = {
        interest: this.value.interest || '',
        infoRequest: this.value.infoRequest || '',
        conversationEnd: this.value.conversationEnd || ''
      }
      this.$nextTick(() => {
        this.isUpdatingFromParent = false
      })
    }
  },
  methods: {
    getDefaultInfoRequestTemplate () {
      return 'היי [שם המועמד], תודה על הפנייה!\nאשמח לקבל ממך כמה פרטים נוספים כדי לבדוק התאמה למשרה של [שם המשרה]:\n- ניסיון רלוונטי\n- זמינות להתחלה\n- ציפיות שכר'
    },

    getDefaultConversationEndTemplate () {
      // Get operation name from settings or default to 'suitup'
      let operationName = 'suitup'

      try {
        if (this.$settings && this.$settings.get) {
          const appName = this.$settings.get({ path: 'app_name' })
          if (appName && typeof appName.toLowerCase === 'function') {
            operationName = appName.toLowerCase()
          }
        }
      } catch (error) {
        console.warn('Could not get app name from settings, using default')
      }

      switch (operationName) {
        case 'suitup':
          return `תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע
ותמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו [קישור לעמוד המשרות של אופרציה רלווונטית]
וכדאי לעקוב אחרינו:
  בפייסבוק👍  https://www.facebook.com/suitup.co.il
  בלינקדאין👍  https://www.linkedin.com/company/suitup-io
ובאינסטגרם👍  https://www.instagram.com/suitup.co.il`

        case 'rebase':
          return `תודה רבה על העדכון.
בכל מקרה, תמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו. אני מצרפת עבורך קישורים למערכת Rebase שם המשרות שלנו מתעדכנות כל הזמן👷🏼
כדאי לעדכן את הפרטים שלך ולהגיש מועמדות למשרות נוספות הרלוונטיות עבורך
 https://web.rebase.co.il   
⚡יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (כדאי שיציינו שהגיעו דרכך לטובת מבצע חבר מביא חבר שלנו 😏)
המשך יום נעים, Rebase :)`

        case 'piola':
          return `תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע
ותמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו [קישור לעמוד המשרות של אופרציה רלווונטית]
וכדאי לעקוב אחרינו:
  בפייסבוק👍  https://www.facebook.com/PiolaHR
  בלינקדאין👍  https://www.linkedin.com/company/78366537/
ובאינסטגרם👍  https://www.instagram.com/piola_hr`

        default:
          return 'תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע.'
      }
    }
  }
}
</script>

<style scoped>
.whatsapp-templates-container {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #fafafa;
}

.label {
  font-weight: bold;
  color: #333;
  text-align: right;
}

.textarea {
  font-family: inherit;
  line-height: 1.4;
  min-height: 80px;
}

.help {
  text-align: right;
  font-size: 0.85em;
  margin-top: 5px;
}
</style>
